module.exports = __webpack_public_path__ + "fonts/SFUIText-HeavyItalic.543e21c5.woff";